var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getTimeseriesChartOptions } from '../../TimeseriesChart/utils';
import { PAGE_BG_COLOR, POSITIVE_COLOR, TIMECHART_COLORS, } from '../../../constants/chart';
export const backCastingTimeSeriesChartOptions = ({ pnlSeries, varSeries, varSeriesLimit, scrollable, height, width, customOptions, }) => {
    let showBreaches = false;
    let limitSeriesData = [];
    const customOptionsWithDefaultColors = Object.assign(Object.assign({}, customOptions), { colors: (customOptions === null || customOptions === void 0 ? void 0 : customOptions.colors) ||
            TIMECHART_COLORS.slice().reverse().concat([POSITIVE_COLOR]) });
    const _a = getTimeseriesChartOptions(varSeries, scrollable, height, width, customOptionsWithDefaultColors), { series } = _a, config = __rest(_a, ["series"]);
    if (varSeriesLimit) {
        const limitSeries = varSeries.find(({ name }) => name === varSeriesLimit);
        if (limitSeries) {
            showBreaches = true;
            limitSeriesData = limitSeries.data;
        }
    }
    return Object.assign(Object.assign({}, config), { 
        // the typings for Highcharts dont allow for series with different in the same
        // chart config
        // @ts-ignore
        series: series.concat([
            {
                type: 'column',
                name: pnlSeries.name,
                // for some reason tsc doesn't like the mapping to expanded
                // object type
                // @ts-ignore
                data: pnlSeries.data.map(([datestamp, value], index) => ({
                    x: datestamp,
                    y: value,
                    borderColor: PAGE_BG_COLOR,
                    color: showBreaches && limitSeriesData[index][1] > value
                        ? 'red'
                        : POSITIVE_COLOR,
                })),
            },
        ]) });
};
//# sourceMappingURL=backtesingConfig.js.map